import { GridColumnConfig } from "../../../models/gridCoumnConfig";

export const rebateProcessingColumns: GridColumnConfig[] = [
  {
    title: 'Work Order#',
    field: 'workOrderNumber',
    filter: 'text',
    searchable: true,
    width: '180px'
  },
  {
    title: 'Customer',
    field: 'customerName',
    filter: 'text',
    searchable: true,
    width: '220px'
  },
  {
    title: 'Office',
    field: 'officeName',
    filter: 'text',
    searchable: true,
    width: '220px'
  },
  {
    title: 'Project',
    field: 'projectName',
    filter: 'text',
    searchable: true,
    width: '220px'
  },
  {
    title: 'Jobsite',
    field: 'jobSite',
    filter: 'text',
    searchable: true,
    width: '180px'
  },
  {
    title: 'Lot#',
    field: 'unitName',
    filter: 'text',
    searchable: true,
    width: '180px'
  },
  {
    title: 'Rebate/Utility Company',
    field: 'utilRebateCompanyName',
    filter: 'text',
    searchable: true,
    width: '210px'
  },
  {
    title: 'Rebate Submitted On',
    field: 'rebateSubmitted',
    filter: 'text',
    searchable: true,
    width: '210px'
  },
  {
    title: 'Address',
    field: 'address',
    filter: 'text',
    searchable: true,
    width: '220px'
  },
  {
    title: 'Assigned To',
    field: 'assignee',
    filter: 'text',
    searchable: true,
    width: '230px'
  },
  {
    title: 'Service Type',
    field: 'serviceGroupName',
    filter: 'text',
    searchable: true,
    width: '180px'
  },
  {
    title: 'ACH Area',
    field: 'achArea',
    filter: 'numeric',
    searchable: true,
    width: '140px'
  },
  {
    title: 'Volume',
    field: 'volume',
    filter: 'numeric',
    searchable: true,
    width: '140px'
  },
  {
    title: 'Window Area',
    field: 'windowArea',
    filter: 'numeric',
    searchable: true,
    width: '140px'
  },
  {
    title: 'Status',
    field: 'planReviewTaskStatus',
    filter: 'text',
    searchable: true,
    width: '160px'
  },
  {
    title: 'Final Scheduled On',
    field: 'finalScheduledDate',
    filter: 'text',
    searchable: true,
    width: '180px'
  },
];
